<div class="grid margin-top-xxbig">
  <div class="cell cell-medium-col-span-6 cell-medium-col-start-2 cell-large-col-span-8 cell-large-col-start-3">
    <div class="text-center">
      <div class="flex flex-justify-center">
        <div class="icon-container">
          <ng-container *ngFor="let content of data.content; let contentIndex = index;">
            <mat-card class="icon-card card-{{ contentIndex }}" >
              <open-svg-icon [name]="content.icon" class="medium"></open-svg-icon>
            </mat-card>
          </ng-container>
        </div>
      </div>
      <div class="flex flex-justify-center margin-bottom-xxlarge">
        <div class="progress-bar-container">
          <div class="progress-bar"></div>
        </div>
      </div>
    </div>

    <div class="grid text-blocks-container">
      <ng-container *ngFor="let content of data.content; let contentIndex = index;">
        <div class="cell cell-medium-col-span-8 cell-medium-col-start-1 cell-large-col-span-10 cell-large-col-start-2 text-block block-{{ contentIndex }}">
          <h1 *ngIf="content.heading" class="margin-bottom-medium">{{ content.heading }}</h1>
          <p>{{ content.text }}</p>
        </div>
      </ng-container>
    </div>
    <div class="grid">
      <div class="cell cell-medium-col-span-8 cell-medium-col-start-1 cell-large-col-span-10 cell-large-col-start-2 disclaimer text-xsmall">
        <p class="margin-vertical-medium">The page is loading. Do not refresh your browser.</p>
      </div>
    </div>
  </div>
</div>
